import React from 'react';
import classNames from 'classnames';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import dashboardStyles from '../eimDashboard.module.scss';
import { ExecutiveSection } from '../eimDashboardUtils';

type Props = {
    section: ExecutiveSection;
    onMetricDoubleClick?: (filterType?: string) => void;
};

const EimExecutiveSectionCard: React.FC<Props> = ({ section, onMetricDoubleClick }) => {
    return (
        <article className={dashboardStyles.sectionCard}>
            <div className={dashboardStyles.sectionHeader}>
                <div>
                    <span className={dashboardStyles.eyebrow}>{section.key}</span>
                    <h2 className={dashboardStyles.sectionTitle}>{section.title}</h2>
                </div>
                <span className={dashboardStyles.sectionChip}>{section.chip}</span>
            </div>
            <p className={dashboardStyles.sectionDescription}>{section.description}</p>
            <div className={dashboardStyles.metricGrid}>
                {section.metrics.map((metric) => (
                    <button
                        type="button"
                        className={classNames(dashboardStyles.metricTile, {
                            [dashboardStyles.metricTileNeutral]: metric.tone === 'neutral',
                            [dashboardStyles.metricTilePositive]: metric.tone === 'positive',
                            [dashboardStyles.metricTileWarning]: metric.tone === 'warning',
                            [dashboardStyles.metricTileCritical]: metric.tone === 'critical',
                            [dashboardStyles.metricTileInteractive]: Boolean(metric.filterType),
                        })}
                        key={metric.label}
                        onClick={() => onMetricDoubleClick?.(metric.filterType)}
                        disabled={!metric.filterType}
                    >
                        <div className={dashboardStyles.metricLabelWithHint}>
                            <span className={dashboardStyles.metricLabel}>{metric.label}</span>
                            {metric.hint ? (
                                <Tooltip title={metric.hint}>
                                    <InfoCircleOutlined className={dashboardStyles.metricHintIcon} />
                                </Tooltip>
                            ) : null}
                        </div>
                        <span className={dashboardStyles.metricValue}>{metric.value}</span>
                        <span className={dashboardStyles.metricContext}>{metric.context}</span>
                    </button>
                ))}
            </div>
        </article>
    );
};

export default EimExecutiveSectionCard;
